import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../hooks';
export const ConfigZigbeeDeviceJson = (_props) => {
    const { id } = useParams();
    const node_id = Number(id);
    const zigbee_nodes = useAppSelector(state => state.definitions.zigbee_nodes);
    const zigbee_node = zigbee_nodes[node_id];
    let page;
    if (zigbee_node)
        page = (_jsx("pre", { children: JSON.stringify(zigbee_node, null, 4) }));
    else
        page = '';
    return (_jsxs("div", { className: "page-container", children: [_jsx("h1", { children: "Zigbee device json" }), page] }));
};
